var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUpdateSource = function SvgUpdateSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    width: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
    fill: "#f4af3d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
    fill: "#fff",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 19.334h6.666V21h-6.666zm0-3.334h6.666v1.667h-6.666zm5-8.333H11c-.917 0-1.667.75-1.667 1.667v13.333c0 .917.742 1.667 1.659 1.667H21c.917 0 1.667-.75 1.667-1.667v-10zm3.333 15H11V9.334h5.833V13.5H21z",
    fill: "#f4af3d"
  })));
};
export default SvgUpdateSource;